import type { RecorderType } from '@common/enums';
import { fetchJson } from '@frontend/store/fetch';

const baseUrl = '/api/requests';

export async function getRequest(
    requestId: string,
    signal: AbortSignal
): Promise<{
    customControlData: {
        procedureType: string;
    };
    isDirectProcedureAdded: boolean;
}> {
    const result = await fetchJson({
        method: 'GET',
        signal,
        url: `${baseUrl}/${requestId}`,
    });

    return result.json;
}

export async function getRequestProcedure(
    requestId: string,
    signal: AbortSignal
): Promise<{
    customControlData: {
        configurationDatetime: string;
        procedureType: string;
        recorderType: RecorderType;
    };
    id: string;
    patientId: string;
}> {
    const result = await fetchJson({
        method: 'GET',
        signal,
        url: `${baseUrl}/${requestId}/procedure`,
    });

    return result.json;
}
